import script from "./rewardRecord.vue?vue&type=script&setup=true&lang=js"
export * from "./rewardRecord.vue?vue&type=script&setup=true&lang=js"

import "./rewardRecord.vue?vue&type=style&index=0&id=65ffd364&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65ffd364"]])

export default __exports__